import { Flyout } from 'ui/dialog/flyout/flyout';

const MIN_DISTANCE_FROM_EDGE_FOR_ARROW = 30;

export class MapFlyoutHandler {

  #map;
  #closeOnInsideClick;
  #closeOnOutsideClick;
  #flyout;
  #invisibleFlyoutTarget;
  #draggingOnFlyout = false;

  constructor (map, { closeOnOutsideClick = false, closeOnInsideClick = false } = {}) {
    this.#map = map;
    this.#closeOnInsideClick = closeOnInsideClick;
    this.#closeOnOutsideClick = closeOnOutsideClick;
  }

  displayFlyout (coordinates, content, verticalOffset = 0, flyoutStyleClass = '') {
    this._createAndAddInvisibleFlyoutTargetIfNeeded();
    const position = this.#map.getPixelFromCoordinate(coordinates);
    this.#invisibleFlyoutTarget.style.top = position[1] + 'px';
    this.#invisibleFlyoutTarget.style.left = position[0] + 'px';

    this.closeFlyout();
    this.#flyout = new Flyout({
      displayArrow: !this._isCloseToRightOrLeftMapEdge(position),
      closeOnInsideClick: this.#closeOnInsideClick,
      closeOnOutsideClick: this.#closeOnOutsideClick,
      content,
      styleClass: flyoutStyleClass
    });
    document.body.appendChild(this.#flyout);
    const maxFlyoutHeight = Math.max(100, (this.#map.getTargetElement().offsetHeight / 2) - 50);
    this.#flyout.querySelector('dialog.d-flyout').style.maxHeight = `${maxFlyoutHeight}px`;
    this.#flyout.show(this.#invisibleFlyoutTarget, {
      at: 'center bottom',
      my: 'center top'
    }, 0, null, verticalOffset);
  }

  closeFlyout () {
    if (this.#flyout && this.#flyout.open) {
      this.#flyout.close();
    }
  }

  clear () {
    if (this.#invisibleFlyoutTarget && this.#invisibleFlyoutTarget.parentElement) {
      this.#invisibleFlyoutTarget.remove();
      this.#invisibleFlyoutTarget = null;
    }
  }

  _isCloseToRightOrLeftMapEdge (position) {
    const x = position[0];
    return x < MIN_DISTANCE_FROM_EDGE_FOR_ARROW
      || x > this.#map.getTarget().offsetWidth - MIN_DISTANCE_FROM_EDGE_FOR_ARROW;
  }

  _createAndAddInvisibleFlyoutTargetIfNeeded () {
    if (!this.#invisibleFlyoutTarget) {
      this.#invisibleFlyoutTarget = document.createElement('div');
      this.#invisibleFlyoutTarget.id = 'invisibleFlyoutTarget';
      this.#invisibleFlyoutTarget.style.position = 'absolute';
      // this.#invisibleFlyoutTarget.style.visibility = 'hidden';
      this.#invisibleFlyoutTarget.style.pointerEvents = 'none';
      this.#invisibleFlyoutTarget.style.height = '1px';
      this.#invisibleFlyoutTarget.style.width = '1px';
      this.#map.getTarget().appendChild(this.#invisibleFlyoutTarget);
    }
  }

}
